import { render, staticRenderFns } from "./grass-icon.vue?vue&type=template&id=1d7be0a9"
import script from "./grass-icon.vue?vue&type=script&lang=js"
export * from "./grass-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports